var _defs, _g, _g2, _g3, _g4, _g5, _g6, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileRejected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(11,183,167,0.4);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 22)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,37A13,13,0,1,1,37,24,13.015,13.015,0,0,1,24,37Zm0-24A11,11,0,1,0,35,24,11.013,11.013,0,0,0,24,13Z",
    transform: "translate(-11 -11)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.53 25.531)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.765,31.7A1,1,0,0,1,13.057,30L30,13.058a1,1,0,0,1,1.414,1.414L14.471,31.412a1,1,0,0,1-.706.292Z",
    transform: "translate(-12.765 -12.766)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 28)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,16H4a1,1,0,0,1,0-2H16a1,1,0,0,1,0,2Z",
    transform: "translate(-3 -14)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,19H4a1,1,0,0,1,0-2H14a1,1,0,0,1,0,2Z",
    transform: "translate(-3 -17)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.5,11a4,4,0,1,1,4-4A4,4,0,0,1,10.5,11Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,10.5,5Z",
    transform: "translate(-6.5 -3)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 16)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.5,16a1,1,0,0,1-1-1V13a3,3,0,0,0-3-3h-6a3,3,0,0,0-3,3v2a1,1,0,0,1-2,0V13a5.006,5.006,0,0,1,5-5h6a5.006,5.006,0,0,1,5,5v2A1,1,0,0,1,19.5,16Z",
    transform: "translate(-4.5 -8)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19,42H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H29a5.006,5.006,0,0,1,5,5V17.12a1,1,0,0,1-2,0V5a3,3,0,0,0-3-3H5A3,3,0,0,0,2,5V37a3,3,0,0,0,3,3H19a1,1,0,0,1,0,2Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileRejected);
export default __webpack_public_path__ + "static/media/profile-rejected.4816c2d0726f8ce2b1cff02d54e46c6f.svg";
export { ForwardRef as ReactComponent };